(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class collectionGridBanner extends HTMLElement {
    constructor() {
      super();
      const products = document.querySelectorAll('.collection__products .product-item');
      const position = parseInt(this.dataset.position);
      const _this = this;
      products.forEach(function (product, index) {
        index += 1;
        if (position === index) {
          product.parentNode.insertBefore(_this.querySelector('.collection_grid_banner'), product);
          return false;
        }
      });
      this.remove();
    }
  }
  customElements.define('grid-banner', collectionGridBanner);

  } catch(e) { console.error(e); }
})();
      })();
